exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb-0[data-v-3797a51e] {\n  margin-bottom: 0;\n}\n.mt-0[data-v-3797a51e] {\n  margin-top: 0;\n}", ""]);

// exports
